import { CommonModule, DecimalPipe, UpperCasePipe } from '@angular/common'
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { DashboardResponse } from '@app/modules/events/models/dashboard.model'
import { DashboardService } from '../../dashboard.service'

@Component({
  selector: 'ngx-payment-methods-card',
  templateUrl: './payment-methods-card.component.html',
  styleUrls: ['./payment-methods-card.component.scss'],
  imports: [CommonModule, DecimalPipe, UpperCasePipe]
})
export class PaymentMethodsCardComponent implements OnInit, AfterViewInit {
  @ViewChild('paymentMethods') private chartRef: ElementRef
  @Input() dashboardData: DashboardResponse
  @Input() currencySlug: string
  pos: number
  cash: number
  onlinePayment: number
  legendContainerId: string

  constructor(private _DashboardService: DashboardService) {}

  ngOnInit(): void {
    this.calculatePaymentMethods()
    this.legendContainerId = `legend-container-${Math.floor(Math.random() * 1000)}` // Generate unique ID
  }

  ngAfterViewInit(): void {
    this.renderChart()
  }

  private calculatePaymentMethods(): void {
    const paymentMethod = this.dashboardData?.payment_method
    this.pos = paymentMethod && paymentMethod.pos ? paymentMethod.pos.total_value : 0
    this.cash = paymentMethod && paymentMethod.cash ? paymentMethod.cash.total_value : 0
    this.onlinePayment = paymentMethod && paymentMethod.Online ? paymentMethod.Online.total_value : 0
  }

  private renderChart(): void {
    const ctx = this.chartRef.nativeElement.getContext('2d')
    const posLabel = `POS: ${this.pos} ${this.currencySlug?.toUpperCase()}`
    const cashLabel = `Cash: ${this.cash} ${this.currencySlug?.toUpperCase()}`
    const onlinePaymentLabel = `Online Payment: ${this.onlinePayment} ${this.currencySlug?.toUpperCase()}`
    const backgroundColors = ['rgba(28, 100, 242, 1)', 'rgba(253, 186, 140, 1)', 'rgba(22, 189, 202, 1)']

    const chartOptions = {
      rotation: 1 * Math.PI,
      circumference: 1 * Math.PI,
      cutoutPercentage: 70,
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: 'percentage',
          fontColor: '#fff',
          precision: 2,
          fontSize: 10
        }
      },
      tooltips: {
        enabled: false
      }
    }
    const options = {
      type: 'doughnut',
      labels: [posLabel, cashLabel, onlinePaymentLabel],
      datasets: [
        {
          label: '# of Payments',
          data: [this.pos, this.cash, this.onlinePayment],
          backgroundColor: backgroundColors,
          hoverBackgroundColor: backgroundColors,
          borderWidth: 1
        }
      ],
      chartOptions: chartOptions
    }
    this._DashboardService.renderChart(ctx, this.dashboardData, options)
  }
}
